"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as popout from "./popout";
import { attachOcrLineDropListeners, forceString } from "./ocr_line_drop";
function applyDroppedLine(props, line) {
  const value = forceString(line.chars);
  props.onValueChange(value);
  if (props.inputDropped) {
    props.inputDropped(value, {
      top: line.top,
      left: line.left,
      width: line.width,
      height: line.height
    });
  }
}
function cleanedProps(props) {
  var _b;
  const _a = props, {
    inputDropped: _inputDropped,
    hasLeadingText: _hasLeadingText,
    v3ReskinEnabled: _v3ReskinEnabled,
    showTextArea: _showTextArea,
    typeahead: _typeahead,
    onValueChange
  } = _a, cleaned = __objRest(_a, [
    "inputDropped",
    "hasLeadingText",
    "v3ReskinEnabled",
    "showTextArea",
    "typeahead",
    "onValueChange"
  ]);
  return __spreadProps(__spreadValues({}, cleaned), {
    value: (_b = cleaned.value) != null ? _b : "",
    onChange: (e) => onValueChange(e.target.value)
  });
}
function handlePopoutListenerUpdate(props, value) {
  if (props.typeahead && props.inputDropped) {
    return props.inputDropped(value);
  }
  return props.onValueChange(value);
}
function handleClick(state) {
  popout.setFieldSelection(state.identifier);
}
function renderV3Reskin(props, state) {
  let className = "v3__input";
  if (props.hasLeadingText) {
    className += " v3__input--has-leading-text";
  }
  const inputProps = {
    ref: "input",
    className,
    onClick: () => handleClick(state)
  };
  if (props.showTextArea) {
    return /* @__PURE__ */ jsx("textarea", __spreadValues(__spreadValues({ rows: 1 }, inputProps), cleanedProps(props)));
  } else {
    return /* @__PURE__ */ jsx("input", __spreadValues(__spreadValues({}, inputProps), cleanedProps(props)));
  }
}
class ValueLinkTextDroppableInput extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      identifier: ""
    });
    __publicField(this, "detachOcrLineDrop");
  }
  componentDidMount() {
    const input = ReactDOM.findDOMNode(this.refs.input);
    $(input).droppable({
      drop: (event, ui) => {
        applyDroppedLine(this.props, {
          chars: ui.helper.data("chars"),
          top: ui.helper.data("top"),
          left: ui.helper.data("left"),
          width: ui.helper.data("width"),
          height: ui.helper.data("height")
        });
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      input,
      (line) => applyDroppedLine(this.props, line)
    );
    this.state.identifier = popout.setupDocPageLineFromPopoutListener(
      (value) => handlePopoutListenerUpdate(this.props, value)
    );
  }
  componentWillUnmount() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return renderV3Reskin(this.props, this.state);
    }
    if (this.props.showTextArea) {
      return /* @__PURE__ */ jsx(
        "textarea",
        __spreadProps(__spreadValues({
          "data-component": "ValueLinkTextDroppableInput",
          ref: "input",
          rows: 1
        }, cleanedProps(this.props)), {
          onClick: () => handleClick(this.state)
        })
      );
    } else {
      return /* @__PURE__ */ jsx(
        "input",
        __spreadProps(__spreadValues({
          ref: "input"
        }, cleanedProps(this.props)), {
          onClick: () => handleClick(this.state)
        })
      );
    }
  }
}
export default ValueLinkTextDroppableInput;
